import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import {subscribe} from 'alfa';
import {default as LayoutComponent} from '../layout';

const PrivateRoute = ({ component: Component, layout: Layout, ...rest }) => {
  return (<Route {...rest} render={(props) => (
    rest.user !== null || props.location.pathname === '/login'
      ? <LayoutComponent layout={Layout} component={Component} {...props} />
      : <Redirect to={{
        pathname: '/login',
        search: props.location.search,
        state: { from: props.location }
      }} />
  )} />)
}

export default subscribe(PrivateRoute, ['user']);
